<style>

.margin-top{
  margin-top: 20px;
}
.new-link-box{
  margin: 10px 0;
  padding: 6px 10px;
  border: 1px #0000 solid;
  margin-top: 15px;
  font-size: 25px;
}

</style>

<div class="center margin-top">
  
  <div class="new-link-box" on:click="{ () => selected('website') }"><i class="icon-globe"></i> Website</div>

  <div class="new-link-box" on:click="{ () => selected('facebook') }"><i class="icon-facebook"></i> Facebook</div>
  
  <div class="new-link-box" on:click="{ () => selected('instagram') }"><i class="icon-instagram"></i> Instagram</div>
  
  <div class="new-link-box" on:click="{ () => selected('linkedin') }"><i class="icon-linkedin"></i> LinkedIn</div>
  
  <div class="new-link-box" on:click="{ () => selected('snapchat') }"><i class="icon-snapchat"></i> Snapchat</div>
  
  <div class="new-link-box" on:click="{ () => selected('twitter') }"><i class="icon-twitter"></i> Twitter</div>
    
</div>

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();


function selected(icon) {
  dispatch("selected", {link: { icon: icon, link: "" } } );
}

</script>